import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useRevokeAccess = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.delete(
      `/Project/RemoveUserToProject?projectId=${formData.projectId}&userId=${formData.userId}&roleId=${formData.roleId}`
    );
  });
  return mutation;
};
export default useRevokeAccess;
